import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import { makeStyles } from "@material-ui/core/styles";
import './AgendaMedica.css';

// @material-ui/icons
import AddAlert from "@material-ui/icons/AddAlert";
import Close from "@material-ui/icons/Close";

//happ-icons 
import { IconCalendar, IconMegaphone, IconUpload } from "happ-components/happ-icons/icons";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Icon from "@material-ui/core/Icon";
import UploadFileIcon from '@material-ui/icons/CloudUpload';
import Card from "components/Card/Card.js";
import SnackbarContent from "happ-components/AgendaMedica/SnackbarContent";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import CardBody from "components/Card/CardBody.js";
import styles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import stylesDash from "assets/jss/material-dashboard-pro-react/views/dashboardStyle.js";
import AgendaTimeline from "happ-components/AgendaMedica/AgendaTimeline";
import Loyalty from "@material-ui/icons/Loyalty";
import Button from "components/CustomButtons/Button.js";
import { getMedicalAgenda, saveResultTest } from "happ-redux/happ-actions/agendaMedica/agendaMedicaActions";

import InputsAgenda from 'happ-components/AgendaMedica/InputsAgenda';


const stylesPanel = {
    cardTitle,
    pageSubcategoriesTitle: {
      color: "#3C4858",
      textDecoration: "none",
      textAlign: "center",
    },
    cardCategory: {
      margin: "0",
      color: "#999999",
    },
};

const ProfileStyle = makeStyles(styles);  
const useStyles = makeStyles(stylesPanel);
const dashStyles = makeStyles(stylesDash);

const AgendaMedica = () => {
    const dispatch = useDispatch();
    const [confirmed, setConfirmed] = useState({});
    const classes = useStyles();
    const ProfileClass = ProfileStyle();
    const DashClass = dashStyles();
    useEffect(() => {
        dispatch(getMedicalAgenda());
    }, []);
    const medical_agenda = useSelector(state => state.agenda.medical_agenda);
    const determinations = useSelector(state => state.agenda.determinations);
    const error_server_agenda = useSelector(state => state.agenda.error_server_agenda);
    const allGoodStatus = useSelector(state => state.agenda.allGoodStatus);
    console.log(allGoodStatus)

    const confirmedStep = (_id, test_id, code, stage) => e =>{
        e.preventDefault();
        const pos = `${code}-${stage}`;
        dispatch(saveResultTest(_id, test_id, code, stage));
        setConfirmed(state => ({
            ...state,
            [pos]: !state[pos]
        }));
    }
    let newAgenda;
    if (medical_agenda !== null) {
        const {_id, patient, medicalProgram, derivativeBenefits} = medical_agenda;
        newAgenda = derivativeBenefits?.map(item => {
            let statusColor;
            let link;
            if (item.status === 'active') {
                statusColor = "happ-background-color";
                if (item.stage !== "consulta-compl" && item.stage !== "consulta-diag"){
                    link = true;
                } else {
                    link = false;
                }
            }
            if (item.status === 'locked') {
                statusColor = "badgeIconDefault";
                link = false;
            }
            if (item.status === 'complete' || confirmed[`${item.code}-${item.stage}`]) {
                statusColor = "success";
                link = false;
            }
            return {
                inverted: true,
                badgeIcon: Loyalty,
                linkDownload: link,
                footerCustomClass:'center-footer-custom',
                badgeColor: statusColor,
                title: item.healthBenefit,
                priority: item.priority,
                stage: item.stage,
                code: item.code,
                rankOfTime: item.rankOfTime,
                badColor: statusColor,
                titleColor: statusColor,
                footer: (
                    <GridContainer className={item.code === "presion-arterial" ? 'mobile-container' : null}>
                        <GridItem xs={3} sm={12} md={3} className="content-upload">
                            {(item.stage !== 'consulta-diag' && item.stage !== 'consulta-compl') ? 
                            (
                                <Button 
                                    className={`${statusColor} btn-upload`} 
                                    color={statusColor}
                                > 
                                    <UploadFileIcon />
                                </Button>
                            ) : (
                                <Button 
                                    className={`${statusColor} btn-agendar`} 
                                    color={statusColor}
                                > 
                                Agendar
                            </Button>
                            )}
                        </GridItem>
                        <GridItem xs={5} sm={12} md={5} className="conten-inputs-agenda">
                            <InputsAgenda 
                                code={item.code}
                            />
                        </GridItem>
                        <GridItem xs={4} sm={12} md={4} className="this-center-btn">
                            <Button 
                                className={`${classes.backButton} ${statusColor} btn-confirmed`}
                                color={statusColor}
                                onClick={confirmedStep(_id, item._id, item.code, item.stage)}
                            >
                                Confirmar
                            </Button>
                        </GridItem>
                    </GridContainer>
                ),  
            }
        });
    }
    console.log(newAgenda)
    let status;
    let message;
    return ( 
        <>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardHeader color="rose" icon>
                            <CardIcon className={`${ProfileClass.iconBack} content-icons`}>
                                <IconCalendar />
                            </CardIcon>
                            <h4 className={ProfileClass.cardIconTitle}>
                            </h4>
                        </CardHeader>
                        <CardBody>
                            <GridContainer className="container-top snackbar-icon-agenda">
                                {newAgenda ? (
                                    determinations ? determinations.map(item => {
                                        if ( item.determination !== "Saludable" ) {
                                            message = `Según los exámenes realizados presenta ${item.determinationType} de ${item.determination}`
                                            status = 'warning'
                                            return (
                                                <GridItem xs={12} sm={12} md={12} lg={12} className="info-determinations" key={item._id}> 
                                                    <SnackbarContent
                                                        classWarnig={'warning-back'}
                                                        detInfo={item.determinationGroup}
                                                        message={message}
                                                        link={true}
                                                        title={message}
                                                        spanSnack='custom-snack'
                                                        div={false}
                                                        titleSnack=""
                                                        close
                                                        icon={AddAlert}
                                                        color={status}
                                                    />
                                                </GridItem>
                                            )                           
                                        } 
                                }) : null
                                ) : (
                                    <GridItem xs={12} sm={12} md={12} lg={12} className="">
                                    <SnackbarContent
                                        classWarnig={''}
                                        message={error_server_agenda ? error_server_agenda : ''}
                                        link={false}
                                        title={error_server_agenda ? error_server_agenda : ''}
                                        detInfo={null}
                                        spanSnack='custom-snack'
                                        div={false}
                                        titleSnack=""
                                        close
                                        icon={AddAlert}
                                        color="info"
                                    />
                                    </GridItem>
                                ) }
                                {newAgenda ? (
                                    allGoodStatus ? (
                                        <GridItem xs={12} sm={12} md={12} lg={12} className=""> 
                                            <SnackbarContent
                                                classWarnig={''}
                                                message={'¡Sigue así! todos tus exámenes salieron muy bien, no te descuides y mantén tus buenos hábitos de vida, come sano, haz deporte y no fumes  '}
                                                spanSnack='custom-snack'
                                                link={false}
                                                title={'¡Sigue así! todos tus exámenes salieron muy bien, no te descuides y mantén tus buenos hábitos de vida, come sano, haz deporte y no fumes  '}
                                                div={false}
                                                detInfo={null}
                                                titleSnack=""
                                                close
                                                icon={AddAlert}
                                                color={'success'}
                                            />
                                        </GridItem>
                                    ) : (
                                        <GridItem xs={12} sm={12} md={12} lg={12} className=""> 
                                            <SnackbarContent
                                                classWarnig={''}
                                                message={'Hemos preparado un programa personalizado para su recuperación, el cual mejorará su calidad y años de vida activa.'}
                                                spanSnack='custom-snack'
                                                link={false}
                                                title={'Hemos preparado un programa personalizado para su recuperación, el cual mejorará su calidad y años de vida activa.'}
                                                div={false}
                                                detInfo={null}
                                                titleSnack=""
                                                close
                                                icon={AddAlert}
                                                color={'info'}
                                            />
                                        </GridItem>
                                    )

                                ) : null}
                                <GridItem xs={12} sm={12} md={6}>
                                    {newAgenda ? 
                                        (
                                            <AgendaTimeline simple stories={newAgenda} className="agenda-medica-timeline" />
                                        )
                                    : null}
                                </GridItem>
                            </GridContainer>  
                            <GridContainer className="container-footer-top hidden">
                                <GridItem xs={12} sm={12} md={6}>
                                    <SnackbarContent
                                        message={
                                            'Para controlar la hipertensión te aconsejamos'
                                        }
                                        spanSnack="custom-snack"
                                        titleSnack=""
                                        close
                                        div={false}
                                        icon={AddAlert}
                                        color="info"
                                    />
                                </GridItem>
                            </GridContainer>   
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>  
        </>               
    );
}
 
export default AgendaMedica;